var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCad = function SvgCad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50BEE8",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.115 15.895c0-1.157.726-2.153 2.105-2.153.521 0 .935.156 1.373.534.162.15.18.414.018.582a.406.406 0 0 1-.552-.019c-.246-.258-.498-.329-.839-.329-.923 0-1.367.654-1.367 1.386 0 .744.438 1.427 1.367 1.427.341 0 .66-.138.935-.384a.404.404 0 0 1 .551.072c.096.132.144.354-.066.564-.42.39-.923.468-1.42.468-1.451 0-2.105-.99-2.105-2.148M8.587 18c-.192-.108-.312-.324-.192-.576l1.72-3.364c.162-.318.595-.329.745 0l1.69 3.364c.246.468-.48.84-.695.372l-.265-.528H9.377l-.258.528c-.095.204-.316.247-.532.204m2.579-1.523-.678-1.482-.737 1.483zM13.66 18c-.199 0-.415-.108-.415-.371v-3.407c0-.216.216-.372.414-.372h1.373c2.74 0 2.68 4.15.054 4.15zm.377-3.418v2.686h.995c1.62 0 1.692-2.687 0-2.687z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgCad;